import Swal from "sweetalert2";
import {
  CREATE_ABOUT_SUCCESS,
  DELETE_ABOUT_FAIL,
  DELETE_ABOUT_REQUEST,
  DELETE_ABOUT_SUCCESS,
  FETCH_ABOUT_FAIL,
  FETCH_ABOUT_REQUEST,
  FETCH_ABOUT_SUCCESS,
  SHOW_ABOUT_FAIL,
  SHOW_ABOUT_REQUEST,
  SHOW_ABOUT_SUCCESS,
  UPDATE_ABOUT_FAIL,
  UPDATE_ABOUT_SUCCESS,
} from "../../ActionType/AboutType/about";
import { api } from "../../Api/api";
import { getToken } from "../login";

export const createAboutAction =
  (title, ar_text, en_text, ku_text, image) => (dispatch) => {
    const formData = new FormData();
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    formData.append("title", title);
    formData.append("ar_text", ar_text);
    formData.append("en_text", en_text);
    formData.append("ku_text", ku_text);
    formData.append("image", image);

    api
      .post("about/create", formData, config)
      .then((response) => {
        const { status, data } = response;
        if (status == 201) {
          dispatch({
            type: CREATE_ABOUT_SUCCESS,
            payload: data,
          });
          Swal.fire({
            icon: "success",
            timer: 2000,

            title: "Goode Job",
            text: "Information was Saved Successfuly",
          });
        }
      })
      .catch((erro) => {
        console.log(erro);
        Swal.fire({
          icon: "error",
          timer: 2000,

          title: "Opps ...",
          text: "Check Your Request",
        });
      });
  };

export const getAboutAction = (page) => (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params:{
        page
    }
  };

  dispatch({
    type: FETCH_ABOUT_REQUEST,
  });

  api
    .get("about", config)
    .then((response) => {
      // console.log(response)
      const { status, data } = response;
      if (status == 200) {
        dispatch({
          type: FETCH_ABOUT_SUCCESS,
          payload: data.data,
          total:data.total,
        });
      }
    })
    .catch((erro) => {
      dispatch({
        type: FETCH_ABOUT_FAIL,
        // payload:data,
      });
      // Swal.fire({
      //   icon: "error",
      //   timer: 2000,

      //   title: "Opps ...",
      //   text: "Check Your Request",
      // });
    });
};

export const deleteAboutAction = (id) => (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };

  dispatch({
    type: DELETE_ABOUT_REQUEST,
  });

  api
    .delete("about/delete/" + id, config)
    .then((response) => {
      const { status, data } = response;
      if (status == 200) {
        
        dispatch({
          type: DELETE_ABOUT_SUCCESS,
          payload: data.data,
          
        });
        Swal.fire({
          icon: "success",
          timer: 2000,

          title: "Goode Job",
          text: "Information was Delete Successfuly",
        });
      }
    })
    .catch((erro) => {
      dispatch({
        type: DELETE_ABOUT_FAIL,
        // payload:data,
      });
      Swal.fire({
        icon: "error",
        timer: 2000,

        title: "Opps ...",
        text: "Check Your Request",
      });
    });
};

export const shoeAboutAction = (id) => (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };

  dispatch({
    type: SHOW_ABOUT_REQUEST,
  });

  api
    .get("about/show/" + id, config)
    .then((response) => {
      // console.log(response)
      const { status, data } = response;
      if (status == 200) {
        console.log(data);
        dispatch({
          type: SHOW_ABOUT_SUCCESS,
          payload: data,
        });
      }
    })
    .catch((erro) => {
      dispatch({
        type: SHOW_ABOUT_FAIL,
        // payload:data,
      });
      Swal.fire({
        icon: "error",
        timer: 2000,

        title: "Opps ...",
        text: "Check Your Request",
      });
    });
};

export const updateAboutAction =  (id,title, ar_text, en_text, ku_text, image) => (dispatch) => {
    const formData = new FormData();
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    formData.append("title", title);
    formData.append("ar_text", ar_text);
    formData.append("en_text", en_text);
    formData.append("ku_text", ku_text);
    formData.append("image", image);
    

  api
    .post(`about/update/${id}` ,formData, config)
    .then((response) => {
      console.log(response)
      const { status, data } = response;
      if (status == 200) {
        // console.log(data);
        dispatch({
          type: UPDATE_ABOUT_SUCCESS,
          payload: data,
        });

        Swal.fire({
            icon: "success",
            timer: 2000,

            title: "Goode Job",
            text: "Information was Update Successfuly",
          });
      }
    })
    .catch((erro) => {
      dispatch({
        type: UPDATE_ABOUT_FAIL,
        // payload:data,
      });
      Swal.fire({
        icon: "error",
        timer: 2000,

        title: "Opps ...",
        text: "Check Your Request",
      });
    });
};
